import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Checkout } from "./types";

export default {
  adjustOrderInfo: (
    apiInfo: ModuleApiInfo,
    args: Checkout.Api.AdjustOrderInfoRequest
  ): Promise<HttpApiResponse<Checkout.Api.AdjustOrderInfoResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/checkout/orderInfo`, args),
  init: (apiInfo: ModuleApiInfo, args: Checkout.Api.InitRequest): Promise<HttpApiResponse<Checkout.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/checkout`, args),
  payment: (
    apiInfo: ModuleApiInfo,
    args: Checkout.Api.PaymentRequest
  ): Promise<HttpApiResponse<Checkout.Api.PaymentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/checkout/payment`, args),
  placeOrder: (
    apiInfo: ModuleApiInfo,
    args: Checkout.Api.PlaceOrderRequest
  ): Promise<HttpApiResponse<Checkout.Api.PlaceOrderResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/checkout/placeOrder`, args),
  getIntegrationParameters: (
    apiInfo: ModuleApiInfo,
    id: string
  ): Promise<HttpApiResponse<Checkout.Api.IntegrationParameter[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/checkout/integration/${id}/parameters`, undefined, "memory")
};
